export default __webpack_public_path__ + "static/media/h5-section2-bg4.84fe1a43.png";